import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/login", { replace: true }); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        localStorage.setItem("zfd_token", data.access_token);
        await refresh();
        // Clean hash before navigation
        window.history.replaceState(null, "", window.location.pathname);
        let dest;
        if (data.user.role === "admin" || data.user.role === "sub_admin") dest = "/admin";
        else if (data.is_new_user) dest = "/welcome";
        else dest = "/wall";
        navigate(dest, { replace: true });
      } catch (e) {
        navigate(`/login?error=${encodeURIComponent(formatErr(e))}`, { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen zfd-canvas flex flex-col items-center justify-center text-white" data-testid="auth-callback">
      <Loader2 className="text-[#FBBF24] animate-spin" size={36} />
      <div className="mt-4 text-sm uppercase tracking-[0.28em] text-[#FBBF24] font-bold">Finalizing Operator Session…</div>
      <div className="mt-1 text-xs text-white/50">Securely exchanging tokens with our ledger.</div>
    </div>
  );
}
